<template>
  <aside class="disclaimers-container">
    <div class="text-left py-0">
      <p>{{ $t('disclaimer') }}</p>
    </div>
    <div id="captcha-container">
      <captcha-policy
        v-if="isPlaceOrderRecaptchaSplitEnabled"
        id="disclaimer-captcha-policy"
      />
    </div>
    <div id="brand-disclaimers">
      <div class="text-left">
        <p
          v-for="(disclaimer, index) in disclaimers"
          :key="index"
          v-html="disclaimer"
        />
      </div>
    </div>
  </aside>
</template>

<script>
import { mapGetters } from 'vuex'
import { APP_GET_DISCLAIMERS } from '../store/get-types'
import CaptchaPolicy from '@/components/shared/captcha/CaptchaPolicy'
import { RL_PLACE_ORDER_RECAPTCHA } from '@/plugins/split/ActiveSplits'

export default {
  name: 'Disclaimers',
  components: { CaptchaPolicy },
  computed: {
    ...mapGetters({
      disclaimers: APP_GET_DISCLAIMERS
    }),
    isPlaceOrderRecaptchaSplitEnabled () {
      return this.$isSplitEnabled(RL_PLACE_ORDER_RECAPTCHA)
    }
  }
}
</script>

<style lang="scss">
.disclaimers-container {
  max-width: 1500px;
  padding: 72px 0 0;
  margin: 0 auto;
}

#brand-disclaimers {
  word-break: break-word;
  a {
    color: inherit;
    text-decoration: underline;
  }
}

#captcha-container {
  padding: 56px 0 0;
}

#disclaimer-captcha-policy {
  a {
    color: inherit;
    text-decoration: underline;
  }
}
</style>
